/**
 * @preserve
 * GeoJSON -> SVG text renderer
 *
 * @license MIT
 * @copyright 2016 Alexander Milevski <info@w8r.name>
 */
module.exports = require('./src/renderer');



//////////////////
// WEBPACK FOOTER
// ./node_modules/geojson-to-svg/index.js
// module id = 602
// module chunks = 0 1